import Vue from "vue";
import VueRouter from "vue-router";
import ListView from "../views/ListView.vue";
import DenoView from "@/views/DenoView.vue";
import FournisseurView from "@/views/FournisseurView.vue";
import ProduitView from "@/views/ProduitView.vue";
import MultiCriteresView from "@/views/MultiCriteresView.vue";
//import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: ListView,
  },
  // route temporaire pour tests
  {
    path: "/bd-22-test",
    name: "tempTestHome",
    redirect: { name: "home" },
  },
  {
    path: "/search",
    name: "multiCriteres",
    component: MultiCriteresView,
  },
  // Listes
  {
    path: "/denominations-communes",
    name: "denos-communes",
    component: ListView,
  },
  {
    path: "/denominations-communes/:id/fournisseurs",
    name: "fournisseurs-deno-commune",
    component: ListView,
  },
  {
    path: "/denominations-communes/:id/produits",
    name: "produits-deno-commune",
    component: ListView,
  },
  {
    path: "/fournisseurs",
    name: "fournisseurs",
    component: ListView,
  },
  {
    path: "/fournisseurs/:id/denominations-communes",
    name: "denos-communes-fournisseur",
    component: ListView,
  },
  {
    path: "/fournisseurs/:id/produits",
    name: "produits-fournisseur",
    component: ListView,
  },
  {
    path: "/produits",
    name: "produits",
    component: ListView,
  },
  {
    path: "/rechercher/resultats",
    name: "multiCriteresListe",
    component: ListView,
  },
  // Fiches
  {
    path: "/denominations-communes/:id",
    name: "deno-commune",
    component: DenoView,
    props: (route) => ({ id: parseInt(route.params.id) }),
  },
  {
    path: "/fournisseurs/:id",
    name: "fournisseur",
    component: FournisseurView,
    props: (route) => ({ id: parseInt(route.params.id) }),
  },
  {
    path: "/dispositif-medical/:id",
    name: "produit",
    component: ProduitView,
    props: (route) => ({ id: parseInt(route.params.id) }),
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
